var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _c("category-image-carousel", {
                    ref: "categoryImageCarousel",
                    attrs: {
                      "image-urls-data": _vm._f("itemImages")(
                        _vm.item.images,
                        _vm.imageUrlAccessor
                      ),
                      alt: _vm._f("itemName")(_vm.item),
                      "item-url": _vm._f("itemURL")(
                        _vm.item,
                        _vm.urlWithVariationId
                      ),
                      "enable-carousel":
                        _vm.$ceres.config.item.enableImageCarousel,
                      "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
                    }
                  })
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.item.item.condition.id == 1
            ? _c("div", { staticClass: "condition special-tags p-2" }, [
                _c("span", { staticClass: "badge badge-bundle bg-info" }, [
                  _vm._v(
                    "\n                          " +
                      _vm._s(
                        _vm.$translate("babyVueTheme::Catview.Condition")
                      ) +
                      "\n                     "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("store-special", [
            _vm.storeSpecial ||
            _vm.item.variation.bundleType === "bundle" ||
            _vm.item.item.itemType === "set"
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content px-0 px-md-3" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title font-weight-bold mb-4",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "thumb-meta d-flex justify-content-between mt-2 mb-2 mb-md-0"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "availability d-flex align-items-center" },
                      [
                        _c("div", {
                          staticClass: "availability-preview",
                          class:
                            "availability-" + _vm.item.variation.availability.id
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2 font-weight-bold" }, [
                          _vm._v(
                            _vm._s(_vm.item.variation.availability.names.name)
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "fs-price d-flex flex-wrap justify-content-end"
                      },
                      [
                        _vm._t("before-prices"),
                        _vm._v(" "),
                        _c("div", { staticClass: "prices" }, [
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.price.value
                            ? _c("div", { staticClass: "price-view-port" }, [
                                _vm.item.prices.specialOffer
                                  ? _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n\t\t                                    " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.default.unitPrice
                                                .formatted,
                                              true
                                            )
                                          ) +
                                          "\n\t\t                                "
                                      )
                                    ])
                                  : _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n\t\t                                    " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              _vm.item.prices.rrp.unitPrice
                                                .formatted
                                            )
                                          ) +
                                          "\n\t\t                                "
                                      )
                                    ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _vm.item.item.itemType === "set"
                                ? [
                                    _vm._v(
                                      "\n\t\t                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemSetPrice",
                                            { price: _vm.itemSetPrice }
                                          )
                                        ) +
                                        "\n\t\t                                "
                                    )
                                  ]
                                : !!_vm.item.item &&
                                  _vm.item.item.salableVariationCount > 1 &&
                                  _vm.$ceres.isCheapestSorting
                                ? [
                                    _vm._v(
                                      "\n\t\t                                     " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.categoryItemFromPrice",
                                            { price: _vm.itemPrice }
                                          )
                                        ) +
                                        "\n\t\t                                "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n\t\t                                    " +
                                        _vm._s(
                                          _vm._f("specialOffer")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            _vm.item.prices,
                                            "unitPrice",
                                            "formatted"
                                          )
                                        ) +
                                        "\n\t\t                                "
                                    )
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "vat small text-muted text-right" },
                          [
                            _vm.showNetPrices
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemExclVAT"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemInclVAT"
                                      )
                                    )
                                  )
                                ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemExclusive"
                                  )
                                ) +
                                "\n\t\t\t\t\t\t  "
                            ),
                            _vm.$ceres.config.global.shippingCostsCategoryId > 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-appearance",
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#shippingscosts"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemShippingCosts"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c("a", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemShippingCosts"
                                      )
                                    )
                                  )
                                ])
                          ]
                        )
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }